import d3 from 'd3';

window.d3 = d3;

export default d3;
